import { PageState, ShareActionOptions } from 'src/redux/modules/page';

import CSSModules from 'react-css-modules';
import CopyLink from 'src/components/SocialShare/CopyLink';
import { Element } from 'react-scroll';
import EmailShare from 'src/components/SocialShare/EmailShare';
import FacebookShare from 'src/components/FacebookShare/FacebookShare';
import React from 'react';
import SmsShare from 'src/components/SocialShare/SmsShare';
import TwitterShare from 'src/components/SocialShare/TwitterShare';
import WhatsAppShare from 'src/components/SocialShare/WhatsAppShare';
import styles from 'src/components/SocialShare/SocialShare.scss';

const shareLocation = 'page > social share';

interface Props {
  shareOnTwitter: (options: ShareActionOptions) => void;
  shareByEmail: (options: ShareActionOptions) => void;
  shareByWhatsApp: (options: ShareActionOptions) => void;
  shareBySms: (options: ShareActionOptions) => void;
  sharePageLink: (options: ShareActionOptions) => void;
  socialShareUrl: string;
  targetAmount: number;
  pitchFor: string;
  ownerName: string;
  name: string;
  isOwner: boolean;
  isActive: boolean;
  page: PageState;
}

class SocialShare extends React.Component<Props> {
  getEmailMessageType = (): ShareMessageTypes => {
    if (this.props.isOwner) {
      return 'ownerShare';
    }
    return 'supporterShare';
  };

  getWhatsAppMessageType = (): ShareMessageTypes => {
    if (this.props.isOwner) {
      return 'ownerShare';
    }
    return 'supporterShare';
  };

  render() {
    return (
      <Element name="share-story">
        <div styleName="container">
          <h1 className="jg-h4" styleName="title">
            Share this story
          </h1>
          <div styleName="mobile-only">
            <div styleName="mobile-button-container">
              <FacebookShare
                isActive={this.props.isActive}
                buttonText="Facebook"
                location={shareLocation}
                customStyle={styles['button-facebook']}
              />
              <EmailShare
                shareByEmail={this.props.shareByEmail}
                socialShareUrl={this.props.socialShareUrl}
                targetAmount={this.props.targetAmount}
                pitchFor={this.props.pitchFor}
                ownerName={this.props.ownerName}
                isActive={this.props.isActive}
                targetCurrency={this.props.page.targetCurrency}
                location={shareLocation}
                className={styles['button-email']}
                messageType={this.getEmailMessageType()}
              />
              <SmsShare
                shareBySms={this.props.shareBySms}
                socialShareUrl={this.props.socialShareUrl}
                targetAmount={this.props.targetAmount}
                pitchFor={this.props.pitchFor}
                ownerName={this.props.ownerName}
                isActive={this.props.isActive}
                isOwner={this.props.isOwner}
                targetCurrency={this.props.page.targetCurrency}
                location={shareLocation}
                className={styles['button-sms']}
              />
              <WhatsAppShare
                shareByWhatsApp={this.props.shareByWhatsApp}
                socialShareUrl={this.props.socialShareUrl}
                targetAmount={this.props.targetAmount}
                pitchFor={this.props.pitchFor}
                ownerName={this.props.ownerName}
                isActive={this.props.isActive}
                targetCurrency={this.props.page.targetCurrency}
                location={shareLocation}
                className={styles['button-whatsapp']}
                messageType={this.getWhatsAppMessageType()}
              />
              <TwitterShare
                shareOnTwitter={this.props.shareOnTwitter}
                socialShareUrl={this.props.socialShareUrl}
                targetAmount={this.props.targetAmount}
                pitchFor={this.props.pitchFor}
                isActive={this.props.isActive}
                isOwner={this.props.isOwner}
                targetCurrency={this.props.page.targetCurrency}
                location={shareLocation}
                className={styles['button-twitter']}
              />
            </div>
            <CopyLink
              className="jg-space-mtsm jg-space-mhsm jg-space-mhxl@md"
              copyText="Copy link"
              copiedText="Link copied"
              isDisabled={!this.props.isActive}
              pageSection={shareLocation}
              socialShareUrl={this.props.socialShareUrl}
              sharePageLink={this.props.sharePageLink}
            />
          </div>
          <div styleName="desktop-button-container">
            <div styleName="social-button-wrapper">
              <FacebookShare
                isActive={this.props.isActive}
                location={shareLocation}
                buttonText="Facebook"
                customStyle="jg-btn jg-btn--facebook"
              />
            </div>
            <div styleName="social-button-wrapper">
              <EmailShare
                shareByEmail={this.props.shareByEmail}
                socialShareUrl={this.props.socialShareUrl}
                targetAmount={this.props.targetAmount}
                pitchFor={this.props.pitchFor}
                ownerName={this.props.ownerName}
                isActive={this.props.isActive}
                targetCurrency={this.props.page.targetCurrency}
                location={shareLocation}
                buttonText="Email"
                className="jg-btn jg-btn--ghost"
                messageType={this.getEmailMessageType()}
              />
            </div>
            <div styleName="social-button-wrapper">
              <TwitterShare
                shareOnTwitter={this.props.shareOnTwitter}
                socialShareUrl={this.props.socialShareUrl}
                targetAmount={this.props.targetAmount}
                pitchFor={this.props.pitchFor}
                isActive={this.props.isActive}
                isOwner={this.props.isOwner}
                targetCurrency={this.props.page.targetCurrency}
                location={shareLocation}
                buttonText="Twitter"
                className="jg-btn jg-btn--twitter"
              />
            </div>
          </div>
        </div>
      </Element>
    );
  }
}

export default CSSModules(SocialShare, styles);



// WEBPACK FOOTER //
// ./src/components/SocialShare/SocialShare.tsx